// source: pushwoosh/channels/messagingApi/v2/payload.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.LiveActivity', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.LocalizedContent', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.NotificationPriority', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Payload', null, global);
goog.exportSymbol('proto.pushwoosh.channels.messagingApi.v2.Payload.KindCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.LiveActivity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.LiveActivity.displayName = 'proto.pushwoosh.channels.messagingApi.v2.LiveActivity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.LocalizedContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.displayName = 'proto.pushwoosh.channels.messagingApi.v2.LocalizedContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.channels.messagingApi.v2.Payload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_);
};
goog.inherits(proto.pushwoosh.channels.messagingApi.v2.Payload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.channels.messagingApi.v2.Payload.displayName = 'proto.pushwoosh.channels.messagingApi.v2.Payload';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.LiveActivity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dismissalDate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentState: (f = msg.getContentState()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.LiveActivity;
  return proto.pushwoosh.channels.messagingApi.v2.LiveActivity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDismissalDate(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setContentState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.LiveActivity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDismissalDate();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getContentState();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional string event = 1;
 * @return {string}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 dismissal_date = 2;
 * @return {number}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.getDismissalDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.setDismissalDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Struct content_state = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.getContentState = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.setContentState = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LiveActivity} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.clearContentState = function() {
  return this.setContentState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.LiveActivity.prototype.hasContentState = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.toObject = function(includeInstance, msg) {
  var f, obj = {
    ios: (f = msg.getIos()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.toObject(includeInstance, f),
    android: (f = msg.getAndroid()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.toObject(includeInstance, f),
    macOs: (f = msg.getMacOs()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.toObject(includeInstance, f),
    amazon: (f = msg.getAmazon()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.toObject(includeInstance, f),
    safari: (f = msg.getSafari()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.toObject(includeInstance, f),
    chrome: (f = msg.getChrome()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.toObject(includeInstance, f),
    firefox: (f = msg.getFirefox()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.toObject(includeInstance, f),
    baiduAndroid: (f = msg.getBaiduAndroid()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.toObject(includeInstance, f),
    huaweiAndroid: (f = msg.getHuaweiAndroid()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.toObject(includeInstance, f),
    xiaomi: (f = msg.getXiaomi()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.toObject(includeInstance, f),
    ie: (f = msg.getIe()) && proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content;
  return proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.deserializeBinaryFromReader);
      msg.setIos(value);
      break;
    case 3:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.deserializeBinaryFromReader);
      msg.setAndroid(value);
      break;
    case 7:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.deserializeBinaryFromReader);
      msg.setMacOs(value);
      break;
    case 9:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.deserializeBinaryFromReader);
      msg.setAmazon(value);
      break;
    case 10:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.deserializeBinaryFromReader);
      msg.setSafari(value);
      break;
    case 11:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.deserializeBinaryFromReader);
      msg.setChrome(value);
      break;
    case 12:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.deserializeBinaryFromReader);
      msg.setFirefox(value);
      break;
    case 16:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.deserializeBinaryFromReader);
      msg.setBaiduAndroid(value);
      break;
    case 17:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.deserializeBinaryFromReader);
      msg.setHuaweiAndroid(value);
      break;
    case 19:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.deserializeBinaryFromReader);
      msg.setXiaomi(value);
      break;
    case 20:
      var value = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.deserializeBinaryFromReader);
      msg.setIe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIos();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.serializeBinaryToWriter
    );
  }
  f = message.getAndroid();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.serializeBinaryToWriter
    );
  }
  f = message.getMacOs();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.serializeBinaryToWriter
    );
  }
  f = message.getAmazon();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.serializeBinaryToWriter
    );
  }
  f = message.getSafari();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.serializeBinaryToWriter
    );
  }
  f = message.getChrome();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.serializeBinaryToWriter
    );
  }
  f = message.getFirefox();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.serializeBinaryToWriter
    );
  }
  f = message.getBaiduAndroid();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.serializeBinaryToWriter
    );
  }
  f = message.getHuaweiAndroid();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.serializeBinaryToWriter
    );
  }
  f = message.getXiaomi();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.serializeBinaryToWriter
    );
  }
  f = message.getIe();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    subtitle: (f = msg.getSubtitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    isCritical: (f = msg.getIsCritical()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    attachment: (f = msg.getAttachment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    threadId: (f = msg.getThreadId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    badges: (f = msg.getBadges()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    trimContent: (f = msg.getTrimContent()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    categoryId: (f = msg.getCategoryId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    interruptionLevel: (f = msg.getInterruptionLevel()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    liveActivity: (f = msg.getLiveActivity()) && proto.pushwoosh.channels.messagingApi.v2.LiveActivity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSubtitle(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 4:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsCritical(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAttachment(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setThreadId(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBadges(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setTrimContent(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCategoryId(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInterruptionLevel(value);
      break;
    case 14:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 15:
      var value = new proto.pushwoosh.channels.messagingApi.v2.LiveActivity;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.LiveActivity.deserializeBinaryFromReader);
      msg.setLiveActivity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSubtitle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIsCritical();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAttachment();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getThreadId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBadges();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTrimContent();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCategoryId();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getInterruptionLevel();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getLiveActivity();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.pushwoosh.channels.messagingApi.v2.LiveActivity.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue subtitle = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getSubtitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setSubtitle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearSubtitle = function() {
  return this.setSubtitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasSubtitle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue body = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasBody = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 4;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 4));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue is_critical = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getIsCritical = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setIsCritical = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearIsCritical = function() {
  return this.setIsCritical(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasIsCritical = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue attachment = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getAttachment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setAttachment = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearAttachment = function() {
  return this.setAttachment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasAttachment = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue sound = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasSound = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue thread_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getThreadId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setThreadId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearThreadId = function() {
  return this.setThreadId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasThreadId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue badges = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getBadges = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setBadges = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearBadges = function() {
  return this.setBadges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasBadges = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue trim_content = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getTrimContent = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setTrimContent = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearTrimContent = function() {
  return this.setTrimContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasTrimContent = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue category_id = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getCategoryId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setCategoryId = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearCategoryId = function() {
  return this.setCategoryId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasCategoryId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 12;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 12));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue interruption_level = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getInterruptionLevel = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setInterruptionLevel = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearInterruptionLevel = function() {
  return this.setInterruptionLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasInterruptionLevel = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Struct root_params = 14;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 14));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional LiveActivity live_activity = 15;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.LiveActivity}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.getLiveActivity = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.LiveActivity} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.LiveActivity, 15));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.LiveActivity|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.setLiveActivity = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.clearLiveActivity = function() {
  return this.setLiveActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos.prototype.hasLiveActivity = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    banner: (f = msg.getBanner()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deliveryPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    vibration: (f = msg.getVibration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    badges: (f = msg.getBadges()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ledColor: (f = msg.getLedColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    iconBackgroundColor: (f = msg.getIconBackgroundColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    showOnLockscreen: (f = msg.getShowOnLockscreen()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    customIcon: (f = msg.getCustomIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    priority: jspb.Message.getFieldWithDefault(msg, 16, 0),
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBanner(value);
      break;
    case 6:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (reader.readEnum());
      msg.setDeliveryPriority(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setVibration(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBadges(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLedColor(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIconBackgroundColor(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowOnLockscreen(value);
      break;
    case 14:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomIcon(value);
      break;
    case 16:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (reader.readEnum());
      msg.setPriority(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBanner();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVibration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBadges();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLedColor();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIconBackgroundColor();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getShowOnLockscreen();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getCustomIcon();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue icon = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue banner = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getBanner = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setBanner = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearBanner = function() {
  return this.setBanner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasBanner = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DeliveryPriority delivery_priority = 6;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getDeliveryPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setDeliveryPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.BoolValue vibration = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getVibration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setVibration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearVibration = function() {
  return this.setVibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasVibration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue badges = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getBadges = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setBadges = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearBadges = function() {
  return this.setBadges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasBadges = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue sound = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasSound = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue led_color = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getLedColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setLedColor = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearLedColor = function() {
  return this.setLedColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasLedColor = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue icon_background_color = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getIconBackgroundColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setIconBackgroundColor = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearIconBackgroundColor = function() {
  return this.setIconBackgroundColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasIconBackgroundColor = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue show_on_lockscreen = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getShowOnLockscreen = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setShowOnLockscreen = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearShowOnLockscreen = function() {
  return this.setShowOnLockscreen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasShowOnLockscreen = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Struct root_params = 14;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 14));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue custom_icon = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getCustomIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setCustomIcon = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearCustomIcon = function() {
  return this.setCustomIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasCustomIcon = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional NotificationPriority priority = 16;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional google.protobuf.StringValue group_id = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    image: (f = msg.getImage()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    buttonText1: (f = msg.getButtonText1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    buttonUrl1: (f = msg.getButtonUrl1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    buttonText2: (f = msg.getButtonText2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    buttonUrl2: (f = msg.getButtonUrl2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 6:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 7:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setButtonText1(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setButtonUrl1(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setButtonText2(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setButtonUrl2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getButtonText1();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getButtonUrl1();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getButtonText2();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getButtonUrl2();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue icon = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue image = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getImage = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasImage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Struct root_params = 6;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 6));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Duration duration = 7;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 7));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue button_text1 = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getButtonText1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setButtonText1 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearButtonText1 = function() {
  return this.setButtonText1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasButtonText1 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue button_url1 = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getButtonUrl1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setButtonUrl1 = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearButtonUrl1 = function() {
  return this.setButtonUrl1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasButtonUrl1 = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue button_text2 = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getButtonText2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setButtonText2 = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearButtonText2 = function() {
  return this.setButtonText2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasButtonText2 = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue button_url2 = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.getButtonUrl2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.setButtonUrl2 = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.clearButtonUrl2 = function() {
  return this.setButtonUrl2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome.prototype.hasButtonUrl2 = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 4:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue icon = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Struct root_params = 4;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 4));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    action: (f = msg.getAction()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    urlArgumentsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addUrlArguments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUrlArgumentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue action = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.getAction = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.hasAction = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string url_arguments = 5;
 * @return {!Array<string>}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.getUrlArgumentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.setUrlArgumentsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.addUrlArguments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari.prototype.clearUrlArgumentsList = function() {
  return this.setUrlArgumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    action: (f = msg.getAction()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    badges: (f = msg.getBadges()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBadges(value);
      break;
    case 8:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBadges();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue action = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getAction = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasAction = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue sound = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasSound = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue badges = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getBadges = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setBadges = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearBadges = function() {
  return this.setBadges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasBadges = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Struct root_params = 8;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 8));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    banner: (f = msg.getBanner()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customIcon: (f = msg.getCustomIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    priority: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBanner(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 7:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomIcon(value);
      break;
    case 10:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (reader.readEnum());
      msg.setPriority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getBanner();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomIcon();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue banner = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getBanner = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setBanner = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearBanner = function() {
  return this.setBanner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasBanner = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue sound = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasSound = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Struct root_params = 7;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 7));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue icon = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue custom_icon = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getCustomIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setCustomIcon = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.clearCustomIcon = function() {
  return this.setCustomIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.hasCustomIcon = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional NotificationPriority priority = 10;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.getPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon.prototype.setPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    banner: (f = msg.getBanner()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deliveryPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    vibration: (f = msg.getVibration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    badges: (f = msg.getBadges()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ledColor: (f = msg.getLedColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    iconBackgroundColor: (f = msg.getIconBackgroundColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    showOnLockscreen: (f = msg.getShowOnLockscreen()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    customIcon: (f = msg.getCustomIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    priority: jspb.Message.getFieldWithDefault(msg, 16, 0),
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBanner(value);
      break;
    case 6:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (reader.readEnum());
      msg.setDeliveryPriority(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setVibration(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBadges(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLedColor(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIconBackgroundColor(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowOnLockscreen(value);
      break;
    case 14:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomIcon(value);
      break;
    case 16:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (reader.readEnum());
      msg.setPriority(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBanner();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVibration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBadges();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLedColor();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIconBackgroundColor();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getShowOnLockscreen();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getCustomIcon();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue icon = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue banner = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getBanner = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setBanner = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearBanner = function() {
  return this.setBanner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasBanner = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DeliveryPriority delivery_priority = 6;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getDeliveryPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setDeliveryPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.BoolValue vibration = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getVibration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setVibration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearVibration = function() {
  return this.setVibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasVibration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue badges = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getBadges = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setBadges = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearBadges = function() {
  return this.setBadges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasBadges = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue sound = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasSound = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue led_color = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getLedColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setLedColor = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearLedColor = function() {
  return this.setLedColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasLedColor = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue icon_background_color = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getIconBackgroundColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setIconBackgroundColor = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearIconBackgroundColor = function() {
  return this.setIconBackgroundColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasIconBackgroundColor = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue show_on_lockscreen = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getShowOnLockscreen = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setShowOnLockscreen = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearShowOnLockscreen = function() {
  return this.setShowOnLockscreen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasShowOnLockscreen = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Struct root_params = 14;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 14));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue custom_icon = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getCustomIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setCustomIcon = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearCustomIcon = function() {
  return this.setCustomIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasCustomIcon = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional NotificationPriority priority = 16;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional google.protobuf.StringValue group_id = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    banner: (f = msg.getBanner()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deliveryPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    vibration: (f = msg.getVibration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    badges: (f = msg.getBadges()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ledColor: (f = msg.getLedColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    soundEnabled: (f = msg.getSoundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    iconBackgroundColor: (f = msg.getIconBackgroundColor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    showOnLockscreen: (f = msg.getShowOnLockscreen()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    customIcon: (f = msg.getCustomIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    priority: jspb.Message.getFieldWithDefault(msg, 16, 0),
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBanner(value);
      break;
    case 6:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (reader.readEnum());
      msg.setDeliveryPriority(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setVibration(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBadges(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLedColor(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSoundEnabled(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIconBackgroundColor(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowOnLockscreen(value);
      break;
    case 14:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomIcon(value);
      break;
    case 16:
      var value = /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (reader.readEnum());
      msg.setPriority(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBanner();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVibration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBadges();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLedColor();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSoundEnabled();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIconBackgroundColor();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getShowOnLockscreen();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getCustomIcon();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPriority();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue icon = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue banner = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getBanner = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setBanner = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearBanner = function() {
  return this.setBanner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasBanner = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DeliveryPriority delivery_priority = 6;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getDeliveryPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setDeliveryPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.BoolValue vibration = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getVibration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setVibration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearVibration = function() {
  return this.setVibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasVibration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue badges = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getBadges = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setBadges = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearBadges = function() {
  return this.setBadges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasBadges = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue sound = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasSound = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue led_color = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getLedColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setLedColor = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearLedColor = function() {
  return this.setLedColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasLedColor = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue sound_enabled = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getSoundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setSoundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearSoundEnabled = function() {
  return this.setSoundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasSoundEnabled = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue icon_background_color = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getIconBackgroundColor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setIconBackgroundColor = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearIconBackgroundColor = function() {
  return this.setIconBackgroundColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasIconBackgroundColor = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue show_on_lockscreen = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getShowOnLockscreen = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setShowOnLockscreen = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearShowOnLockscreen = function() {
  return this.setShowOnLockscreen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasShowOnLockscreen = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Struct root_params = 14;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 14));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue custom_icon = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getCustomIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setCustomIcon = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearCustomIcon = function() {
  return this.setCustomIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasCustomIcon = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional NotificationPriority priority = 16;
 * @return {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getPriority = function() {
  return /** @type {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.pushwoosh.channels.messagingApi.v2.NotificationPriority} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setPriority = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional google.protobuf.StringValue group_id = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeToLive: (f = msg.getTimeToLive()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    icon: (f = msg.getIcon()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    vibration: (f = msg.getVibration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    sound: (f = msg.getSound()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rootParams: (f = msg.getRootParams()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeToLive(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setVibration(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSound(value);
      break;
    case 8:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootParams(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeToLive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getVibration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSound();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRootParams();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue body = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration time_to_live = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getTimeToLive = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setTimeToLive = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearTimeToLive = function() {
  return this.setTimeToLive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasTimeToLive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue icon = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getIcon = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue vibration = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getVibration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setVibration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearVibration = function() {
  return this.setVibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasVibration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue sound = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getSound = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setSound = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearSound = function() {
  return this.setSound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasSound = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Struct root_params = 8;
 * @return {?proto.google.protobuf.Struct}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getRootParams = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 8));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setRootParams = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearRootParams = function() {
  return this.setRootParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasRootParams = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue group_id = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    iconBadge: (f = msg.getIconBadge()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIconBadge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIconBadge();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue title = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue icon_badge = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.getIconBadge = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.setIconBadge = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.clearIconBadge = function() {
  return this.setIconBadge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE.prototype.hasIconBadge = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesWindows.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesEmail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS;
  return proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSMS.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional PlatformPropertiesIos ios = 1;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getIos = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos, 1));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIos|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setIos = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearIos = function() {
  return this.setIos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasIos = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PlatformPropertiesAndroid android = 3;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getAndroid = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid, 3));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAndroid|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setAndroid = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearAndroid = function() {
  return this.setAndroid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasAndroid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PlatformPropertiesMacOS mac_os = 7;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getMacOs = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS, 7));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesMacOS|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setMacOs = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearMacOs = function() {
  return this.setMacOs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasMacOs = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PlatformPropertiesAmazon amazon = 9;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getAmazon = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon, 9));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesAmazon|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setAmazon = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearAmazon = function() {
  return this.setAmazon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasAmazon = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PlatformPropertiesSafari safari = 10;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getSafari = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari, 10));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesSafari|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setSafari = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearSafari = function() {
  return this.setSafari(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasSafari = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PlatformPropertiesChrome chrome = 11;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getChrome = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome, 11));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesChrome|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setChrome = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearChrome = function() {
  return this.setChrome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasChrome = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional PlatformPropertiesFirefox firefox = 12;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getFirefox = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox, 12));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesFirefox|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setFirefox = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearFirefox = function() {
  return this.setFirefox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasFirefox = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional PlatformPropertiesBaiduAndroid baidu_android = 16;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getBaiduAndroid = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid, 16));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesBaiduAndroid|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setBaiduAndroid = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearBaiduAndroid = function() {
  return this.setBaiduAndroid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasBaiduAndroid = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional PlatformPropertiesHuaweiAndroid huawei_android = 17;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getHuaweiAndroid = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid, 17));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesHuaweiAndroid|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setHuaweiAndroid = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearHuaweiAndroid = function() {
  return this.setHuaweiAndroid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasHuaweiAndroid = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional PlatformPropertiesXiaomi xiaomi = 19;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getXiaomi = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi, 19));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesXiaomi|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setXiaomi = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearXiaomi = function() {
  return this.setXiaomi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasXiaomi = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional PlatformPropertiesIE ie = 20;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.getIe = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE, 20));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.Content.PlatformPropertiesIE|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.setIe = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Content} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.clearIe = function() {
  return this.setIe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Content.prototype.hasIe = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    localizedContentMap: (f = msg.getLocalizedContentMap()) ? f.toObject(includeInstance, proto.pushwoosh.channels.messagingApi.v2.Content.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent}
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.LocalizedContent;
  return proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent}
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getLocalizedContentMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.channels.messagingApi.v2.Content.deserializeBinaryFromReader, "", new proto.pushwoosh.channels.messagingApi.v2.Content());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalizedContentMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.channels.messagingApi.v2.Content.serializeBinaryToWriter);
  }
};


/**
 * map<string, Content> localized_content = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>}
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.prototype.getLocalizedContentMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pushwoosh.channels.messagingApi.v2.Content>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.pushwoosh.channels.messagingApi.v2.Content));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.LocalizedContent} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.prototype.clearLocalizedContentMap = function() {
  this.getLocalizedContentMap().clear();
  return this;};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.KindCase = {
  KIND_NOT_SET: 0,
  CONTENT: 2,
  SILENT: 3
};

/**
 * @return {proto.pushwoosh.channels.messagingApi.v2.Payload.KindCase}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.channels.messagingApi.v2.Payload.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.channels.messagingApi.v2.Payload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Payload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.toObject = function(includeInstance, msg) {
  var f, obj = {
    preset: (f = msg.getPreset()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    content: (f = msg.getContent()) && proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.toObject(includeInstance, f),
    silent: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.channels.messagingApi.v2.Payload;
  return proto.pushwoosh.channels.messagingApi.v2.Payload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Payload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPreset(value);
      break;
    case 2:
      var value = new proto.pushwoosh.channels.messagingApi.v2.LocalizedContent;
      reader.readMessage(value,proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSilent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.channels.messagingApi.v2.Payload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.channels.messagingApi.v2.Payload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.channels.messagingApi.v2.LocalizedContent.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue preset = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.getPreset = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.setPreset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.clearPreset = function() {
  return this.setPreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.hasPreset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LocalizedContent content = 2;
 * @return {?proto.pushwoosh.channels.messagingApi.v2.LocalizedContent}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.getContent = function() {
  return /** @type{?proto.pushwoosh.channels.messagingApi.v2.LocalizedContent} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.channels.messagingApi.v2.LocalizedContent, 2));
};


/**
 * @param {?proto.pushwoosh.channels.messagingApi.v2.LocalizedContent|undefined} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
*/
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.setContent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.hasContent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool silent = 3;
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.getSilent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.setSilent = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pushwoosh.channels.messagingApi.v2.Payload} returns this
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.clearSilent = function() {
  return jspb.Message.setOneofField(this, 3, proto.pushwoosh.channels.messagingApi.v2.Payload.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.channels.messagingApi.v2.Payload.prototype.hasSilent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.pushwoosh.channels.messagingApi.v2.DeliveryPriority = {
  NORMAL: 0,
  HIGH: 1
};

/**
 * @enum {number}
 */
proto.pushwoosh.channels.messagingApi.v2.NotificationPriority = {
  PRIORITY_UNSPECIFIED: 0,
  PRIORITY_MIN: 1,
  PRIORITY_LOW: 2,
  PRIORITY_DEFAULT: 3,
  PRIORITY_HIGH: 4,
  PRIORITY_MAX: 5
};

goog.object.extend(exports, proto.pushwoosh.channels.messagingApi.v2);
